import { useAuthContext } from '../contexts/AuthContext'
import React, { useEffect, useState } from 'react'
import { removeWhiteSpace } from '../utils/utils'
import PageLoading from '../misc/PageLoading'
import { WC_NAME } from '../utils/Constants'
import { useNavigate, useParams } from 'react-router-dom'
import Error from '../Error/Error'
import Bracket from './Bracket'
import BracketV2 from './BracketV2'

const archivePathForScorecard = (scorecardName) => {
  switch (scorecardName) {
    case 'Australia New Zealand 2023':
      return '/archive/aunz'
    case 'Qatar 2022':
      return '/archive/qatar'
    case 'France 2019':
      return '/archive/france'
    default:
      return null
  }
}

export default function ShowBracket() {
  const [bracket, setBracket] = useState(null)
  const [bracketV2, setBracketV2] = useState(false)
  const [canEdit, setCanEdit] = useState(false)
  const [rankings, setRankings] = useState({})
  const [standings, setStandings] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { authorizationHeaders } = useAuthContext()
  const navigate = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    const fetchV1Bracket = () => {
      fetch(`/api/v1/brackets/${id}`, {
        credentials: 'same-origin',
        headers: authorizationHeaders,
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            throw response
          }
        })
        .then(body => {
          setBracket(body.bracket)
          setBracketV2(false)
          if (body.standings) {
            setStandings(body.standings)
          }
          setLoading(false)
        })
        .catch(fetchError => {
          setError(fetchError)
          setLoading(false)
        })
    }

    fetch(`/api/v2/brackets/${id}`, {
      credentials: 'same-origin',
      headers: authorizationHeaders,
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        if (response.status === 404) {
          fetchV1Bracket()
          return null
        }
        throw response
      })
      .then(body => {
        if (!body) return
        setBracket(body.bracket)
        setCanEdit(Boolean(body.can_edit))
        setRankings(body.rankings || {})
        setBracketV2(true)
        setLoading(false)
      })
      .catch(fetchError => {
        setError(fetchError)
        setLoading(false)
      })
  }, [authorizationHeaders, id])

  if (loading) {
    return <div className={removeWhiteSpace(WC_NAME)}>
      <div className="background-image bracket-form-background"/>
      <PageLoading />
    </div>
  } else if (error) {
    return <Error error={error} />
  }

  const archivePath = archivePathForScorecard(bracket?.scorecard?.name)
  const backButtonText = archivePath ? 'Archive' : 'Leaderboard'
  const backButtonOnClick = archivePath ? () => navigate(archivePath) : () => navigate('/leaderboard')

  if (bracketV2) {
    return <BracketV2 bracket={bracket} canEdit={canEdit} rankings={rankings} showBackButton backButtonText={backButtonText} backButtonOnClick={backButtonOnClick} />
  }

  return <Bracket bracket={bracket} standings={standings} showBackButton backButtonText={backButtonText} backButtonOnClick={backButtonOnClick} />
}
